import { Tag } from "@app/types/Cue";

export const PODCAST_KEYWORDS_DATA: {
  name:
    | "marketFocus"
    | "moneyHacks"
    | "lensOn"
    | "wealthBT"
    | "propertyBT"
    | "markToMarket"
    | "brandedContent";
  spotify_link: string;
  apple_link: string;
  tag: Tag;
  description: string;
}[] = [
  {
    name: "marketFocus",
    spotify_link: "https://bt.sg/mfsp",
    apple_link: "https://bt.sg/mfap",
    tag: { name: "Market Focus", uri: "main/market-focus" },
    description:
      "Market Focus is a weekly podcast by The Business Times that looks at the market drivers and movements in Singapore, the region and the globe.",
  },
  {
    name: "moneyHacks",
    spotify_link: "http://bt.sg/oeGN",
    apple_link: "http://bt.sg/oeXe",
    tag: { name: "Money Hacks", uri: "main/money-hacks" },
    description:
      "In this series, The Business Times breaks down actionable financial tips.",
  },
  {
    name: "lensOn",
    spotify_link: "https://bt.sg/lenssp",
    apple_link: "https://bt.sg/lensap",
    tag: { name: "Lens On", uri: "main/lens-on" },
    description:
      "A monthly podcast series from The Business Times on current affairs, societal issues and government policies explored through the lens of how it impacts us in Singapore and the region.",
  },
  {
    name: "wealthBT",
    spotify_link: "http://bt.sg/wbSP",
    apple_link: "https://bt.sg/4DJp",
    tag: { name: "WealthBT", uri: "main/wealthbt" },
    description:
      "Learn to protect and grow your wealth in our monthly podcast series for affluent individuals, hosted by BT wealth editor Genevieve Cua.",
  },
  {
    name: "propertyBT",
    spotify_link: "https://bt.sg/pbSP",
    apple_link: "https://bt.sg/pbAP",
    tag: { name: "PropertyBT", uri: "main/propertybt" },
    description:
      "Get insights from The Business Times on all things Singapore property, to help you in your property investment journey from senior correspondent Leslie Yee and industry players.",
  },
  {
    name: "markToMarket",
    spotify_link: "https://bt.sg/4DJN",
    apple_link: "https://bt.sg/4DJp",
    tag: { name: "Mark to Market", uri: "main/mark-to-market" },
    description:
      "In this series, The Business Times aims to provide analysis and insight on market trends and corporate issues in Singapore.",
  },
  {
    name: "brandedContent",
    spotify_link: "https://bt.sg/bpsp",
    apple_link: "https://bt.sg/bpap",
    tag: { name: "Branded Content", uri: "main/branded-content" },
    description:
      "Finely curated, intelligent, thought-provoking branded content for decision-makers. Inspired by the newsroom of your trusted partner.",
  },
];
